module.exports = __webpack_public_path__ + "static/splash-news-xl-c918d75605aff36bebbdbddbcde228e8.jpg";